import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import Home from './pages/Home';
import functions from './utils/functions'



class App extends Component {


  state = {
    screen: "Login",
    loggedIn: true,
    accessInfo: functions.permissionGuard()
  }

  componentDidMount() {
    this.checkLogin();
  }

  checkLogin() {
    if (!localStorage.getItem("savings@user")) {
      this.setState({
        loggedIn: false
      })
    } else {
      this.setState({
        loggedIn: true
      })
    }
  }
  render() {
    const roleList = functions.roleGuard()
    const USER_BOUNDARY = functions.userBoundary();
    return (
      <Router forceRefresh={true}>

        <Switch>

          {!this.state.loggedIn && <Route exact path="/" component={Home} />}
          {/* {!this.state.loggedIn && <Route exact path="/" component={HomeProv} />} */}

          {/* {!this.state.loggedIn && <Route exact path="/" component={Login} />} */}

          {/* <Route exact path="/login" component={Login} /> */}
          {/* <Route exact path="/forgot-password" component={Forgot} /> */}
          {/* <Route exact path="/" component={Dashboard} /> */}

          {/* <Route exact path="*" component={Error} /> */}

        </Switch>
      </Router>
    )
  }
}
export default App
